'use client'
import { useRef } from 'react'

import type { NavSelection } from './nav-types'

// Closing clears the live selection before the menu finishes animating out.
// Its contents keep the last open selection; opening or going back within an
// open mobile sheet immediately uses the live selection again.
export const useMenuSelection = (open: boolean, current: NavSelection): NavSelection => {
  const lastSelection = useRef(current)
  if (open) {
    lastSelection.current = { ...current }
  }
  return open ? current : lastSelection.current
}
